import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CertificateComponent} from './certificate/certificate.component';
import {ArmFormTitleModule} from '../arm-form/arm-form-title/arm-form-title.module';
import {ArmFormModule} from '../arm-form/arm-form.module';
import {MaterialModule} from '../../material.module';
import {FormsModule} from '@angular/forms';
import {InfraModule} from 'ac-infra';
import { CertificateViewComponent } from './certificate-view/certificate-view.component';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {CertificateReloadDialogComponent} from './certificate-reload-dialog/certificate-reload-dialog.component';



@NgModule({
  exports: [CertificateComponent],
  declarations: [CertificateComponent, CertificateViewComponent, CertificateReloadDialogComponent],
  imports: [
    CommonModule,
    ArmFormTitleModule,
    ArmFormModule,
    MaterialModule,
    FormsModule,
    InfraModule,
    ClipboardModule
  ]
})
export class CertificatesModule { }
